import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { siteConfig, testimonials } from '@/mocks/comics';

export default function About() {
  const pageTitle = `关于我们 - ${siteConfig.name}`;
  const pageDesc = `了解${siteConfig.name}的品牌故事、平台特色与联系方式。${siteConfig.name}致力于为广大韩漫爱好者提供免费、优质的韩国漫画在线阅读服务。`;

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: pageTitle,
            description: pageDesc,
            url: `${siteConfig.url}/about`,
            isPartOf: { '@type': 'WebSite', name: siteConfig.name, url: siteConfig.url },
          }),
        }}
      />
      <Navbar />
      <main>
        <Breadcrumb
          items={[
            { label: '首页', path: '/' },
            { label: '关于我们' },
          ]}
        />

        <section className="max-w-4xl mx-auto px-4 md:px-6 pb-10 md:pb-14">
          <div className="text-center mb-10">
            <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
              关于韩漫大全
            </h1>
            <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
              免费看韩漫网站 · 韩漫大全平台
            </p>
          </div>

          <div className="bg-background-50 border border-background-200 rounded-lg p-6 md:p-8 mb-8">
            <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mb-4 flex items-center gap-2">
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                <i className="ri-building-4-line text-sm"></i>
              </span>
              品牌介绍
            </h2>
            <div className="space-y-4 text-sm text-foreground-700 leading-relaxed">
              <p>
                <strong>韩漫大全</strong>成立于2024年，是国内领先的韩国漫画免费在线阅读平台。我们致力于为广大华语漫画爱好者提供一个内容丰富、更新及时、阅读体验优质的韩漫资源库。
              </p>
              <p>
                平台目前收录了超过<strong className="text-primary-600">500部</strong>韩国漫画作品，涵盖<strong>热血、恋爱、奇幻、悬疑、搞笑</strong>等多种类型，满足不同读者的口味偏好。无论是想追最新连载的热门大作，还是补看已完结的经典神作，韩漫大全都能满足你的需求。
              </p>
              <p>
                我们的核心理念是<strong className="text-primary-600">「让每个人都自由享受韩漫」</strong>。因此，韩漫大全坚持完全免费、无需注册的运营模式，打破一切阅读门槛，让漫画真正回归纯粹的阅读乐趣。
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
            {[
              { icon: 'ri-shield-check-line', title: '完全免费', desc: '无需充值，无需会员，所有漫画免费畅读' },
              { icon: 'ri-flashlight-line', title: '极速更新', desc: '24小时内同步韩国最新连载更新' },
              { icon: 'ri-device-line', title: '多端适配', desc: '电脑、平板、手机均可流畅阅读' },
              { icon: 'ri-translate', title: '专业翻译', desc: '资深团队保证翻译质量和阅读体验' },
              { icon: 'ri-search-line', title: '丰富分类', desc: '五大分类体系，精准匹配你的口味' },
              { icon: 'ri-user-smile-line', title: '无需注册', desc: '打开即看，没有繁琐的注册流程' },
            ].map((item, i) => (
              <div key={i} className="bg-background-50 border border-background-200 rounded-lg p-5 flex gap-4">
                <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 rounded-lg bg-accent-100 text-accent-600">
                  <i className={`${item.icon} text-lg`}></i>
                </div>
                <div>
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1">{item.title}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="bg-background-50 border border-background-200 rounded-lg p-6 md:p-8 mb-8">
            <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mb-6 flex items-center gap-2">
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                <i className="ri-chat-heart-line text-sm"></i>
              </span>
              用户口碑
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {testimonials.map((t, i) => (
                <div key={i} className="bg-background-100 rounded-lg p-5">
                  <div className="flex items-center gap-3 mb-3">
                    <img
                      src={t.avatar}
                      alt={t.name}
                      className="w-10 h-10 rounded-full object-cover"
                    />
                    <div>
                      <div className="font-medium text-sm text-foreground-900">{t.name}</div>
                      <div className="flex text-accent-400 gap-0.5 mt-0.5">
                        {Array.from({ length: t.rating }).map((_, j) => (
                          <i key={j} className="ri-star-fill text-[10px]"></i>
                        ))}
                      </div>
                    </div>
                  </div>
                  <p className="text-xs text-foreground-600 leading-relaxed">{t.comment}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-background-50 border border-background-200 rounded-lg p-6 md:p-8">
            <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mb-6 flex items-center gap-2">
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                <i className="ri-mail-line text-sm"></i>
              </span>
              联系我们
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-3">联系方式</h3>
                <ul className="space-y-3 text-sm text-foreground-600">
                  <li className="flex items-center gap-2">
                    <span className="w-7 h-7 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 flex-shrink-0">
                      <i className="ri-mail-line text-xs"></i>
                    </span>
                    contact@hanmandaquan.com
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="w-7 h-7 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 flex-shrink-0">
                      <i className="ri-wechat-line text-xs"></i>
                    </span>
                    微信公众号：韩漫大全
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="w-7 h-7 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 flex-shrink-0">
                      <i className="ri-weibo-line text-xs"></i>
                    </span>
                    微博：@韩漫大全官方
                  </li>
                </ul>
              </div>
              <div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-3">商务合作</h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                  如果您有合作意向，如版权合作、广告投放、内容互换等，欢迎通过以下方式与我们联系：
                </p>
                <ul className="space-y-2 text-sm text-foreground-600">
                  <li className="flex items-center gap-2">
                    <span className="w-7 h-7 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 flex-shrink-0">
                      <i className="ri-briefcase-line text-xs"></i>
                    </span>
                    biz@hanmandaquan.com
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}